export default function(error, container) {
    if (!error.response) return console.error(error);
    if (error.response.data) {
        container.setState({
            _hasErrored: true,
            _statusCode: error.response.data._statusCode,
            errorMessage: error.response.data.message
        });
    }
}